import React from "react";
import { Card, ListGroup } from "react-bootstrap";

export interface InsuranceInfo {
  title: React.ReactNode;
  description: React.ReactNode;
  benefits: React.ReactNode[];
  examples: React.ReactNode[];
}

type InsuranceCardProps = {
  data: InsuranceInfo;
  imageUrl?: string;
  imageAlt?: string;
  className?: string;
};




 //import InsuranceCard from "./InsuranceCard";
//  import { electriciansInsurance } from "./INFO_Electricians_Insurance_v01";


const InsuranceCard_v01: React.FC<InsuranceCardProps> = ({
  data,
  imageUrl,
  imageAlt = "Insurance image",
  className,
}) => {
  const { title, description, benefits = [], examples = [] } = data;

  return (
    <Card className={className} style={{ overflow: "hidden" }}>
      {imageUrl && <Card.Img variant="top" src={imageUrl} alt={imageAlt} />}
      <Card.Body>
        <Card.Title as="h3" className="h5 mb-2">
          {title}
        </Card.Title>
        <Card.Text className="mb-3">{description}</Card.Text>

        {benefits.length > 0 && (
          <>
            <Card.Subtitle as="h4" className="h6 mt-2 mb-2">
              Benefits
            </Card.Subtitle>
            <ListGroup variant="flush" className="mb-3">
              {benefits.map((b, i) => (
                <ListGroup.Item key={`benefit-${i}`}>{b}</ListGroup.Item>
              ))}
            </ListGroup>
          </>
        )}

        {examples.length > 0 && (
          <>
            <Card.Subtitle as="h4" className="h6 mt-2 mb-2">
              Examples
            </Card.Subtitle>
            <ListGroup variant="flush">
              {examples.map((ex, i) => (
                <ListGroup.Item key={`example-${i}`}>{ex}</ListGroup.Item>
              ))}
            </ListGroup>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default InsuranceCard_v01;


